import AxiosClient from "../../../services/axios.services";

class CampaignsServices {
  getCampaigns = (params) =>
    AxiosClient.get("/api/app/capacitacion_campania/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getCampaignsById = (id) =>
    AxiosClient.get(`/api/app/capacitacion_campania/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveCampaigns = (data) =>
    AxiosClient.post("/api/app/capacitacion_campania/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editCampaigns = (id, data) =>
    AxiosClient.put(`/api/app/capacitacion_campania/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteCampaigns = (id) =>
    AxiosClient.delete(`/api/app/capacitacion_campania/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
  getTrainingsCalendar = (filters = {}) =>
    AxiosClient.get(`/api/app/capacitacion_organizacion_calendario/`, {
      headers: { "Content-Type": "application/json" },
      params: filters,
    });
  getTrainingsEmployeesCalendar = (filters = {}) =>
    AxiosClient.get(`/api/app/capacitacion_organizacion_calendario_empleados/`, {
      headers: { "Content-Type": "application/json" },
      params: filters,
    });
}

export default new CampaignsServices();
